module.exports = __webpack_public_path__ + "media/images/power_plant-a0e3d7e05c781639f755c363c813d664.png";